export enum UNSUPPORTED_BROWSER_TYPE {
  CHROME_ON_IOS = 'CHROME_ON_IOS',
  NOT_CHROME_ON_ANDROID = 'NOT_CHROME_ON_ANDROID',
  EDGE_ON_IOS = 'EDGE_ON_IOS',
}
